"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAttributes = void 0;
var safe_element_1 = require("./safe-element");
function setAttributes(selector, attributes) {
    Object.keys(attributes).forEach(function (prop) {
        var value = attributes[prop];
        if (value !== false) {
            safe_element_1.safeElements(selector).forEach(function (element) {
                element.setAttribute(prop, attributes[prop]);
            });
        }
        else {
            safe_element_1.safeElements(selector).forEach(function (element) {
                element.removeAttribute(prop);
            });
        }
    });
}
exports.setAttributes = setAttributes;
//# sourceMappingURL=set-attributes.js.map